import React from "react"

import "./preloader.css"

//отрисовываем список начислений

interface IPreloader {
  small: boolean
}
export const Preloader = ({ small }: IPreloader) => {
  const preloaderClassName = small ? "circle-preloader circle-preloader_small" : "circle-preloader"

  return (
    <i className={preloaderClassName}></i>
  )
}
